import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getSearchList = (params) => {
    return axios.get(`${backendHost}/api/admin/report-games/search`, {params});
};

export {
    getSearchList
}